import {
  SENSITIVE_DATA_BOOLEAN_NO,
  SENSITIVE_DATA_BOOLEAN_YES,
  SENSITIVE_DATA_NO_VALUE,
} from "constants/sensitiveData";

export const getSensitiveDataBooleanLabel = (value: unknown): string => {
  if (value === true) return SENSITIVE_DATA_BOOLEAN_YES;
  if (value === false) return SENSITIVE_DATA_BOOLEAN_NO;

  return SENSITIVE_DATA_NO_VALUE;
};
